import { Box, Container as ChakraContainer } from '@chakra-ui/react'

/**
 * Responsive Container Component
 * Handles max-width for ultra-wide screens (2K+)
 */
export function ResponsiveContainer({ children, maxW = '1920px', ...props }) {
  return (
    <Box w="full" mx="auto" maxW={ maxW } px={{ base: 4, md: 6, lg: 8 }} { ...props }>
      { children }
    </Box>
  )
}

/**
 * Chakra Container with custom max-widths
 */
export function Container({ children, ...props }) {
  return (
    <ChakraContainer
      maxW={{
        sm: '100%',
        md: '100%',
        lg: '100%',
        xl: '100%',
        '2xl': '1920px',
      }}
      { ...props }
    >
      { children }
    </ChakraContainer>
  )
}

export default ResponsiveContainer
